import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { IconChipComponent } from '@principle-theorem/ng-principle-shared';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { ICustomReportTemplate } from '@principle-theorem/reporting';

@Component({
  selector: 'pr-select-report-template-card',
  templateUrl: './select-report-template-card.component.html',
  styleUrl: './select-report-template-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col gap-2 rounded-md bg-white p-4 shadow-md',
  },
  imports: [MatButton, IconChipComponent, NgCommonModule],
})
export class SelectReportTemplateCardComponent {
  template = input.required<ICustomReportTemplate>();
  selected = output<ICustomReportTemplate>();
  selectLabel = input<string>('Create Report');
  flatButton = input<boolean>(true);
}
